<template>
  <div class="funds-list page-box">
    <query-header
      ref="header"
      :type-list="typeList"
      @toQuery="toQuery"
    ></query-header>
    <div class="page-content">
      <div class="content-header">
        <el-input
          class="search-input"
          v-model="login"
          :placeholder="$t('transaction_account')"
          clearable
        ></el-input>
        <el-button
          :loading="loading"
          type="primary"
          class="search-btn"
          @click="searchHandle"
        >{{$t('search')}}</el-button>
      </div>
      <div class="vs-table-outer">
        <vs-table :noDataText="$t('root.noData')" :data="listData">
          <template
            slot="thead">
            <vs-th>
              {{$t('serial_number')}}
            </vs-th>
            <vs-th>
              {{$t('transaction_account')}}
            </vs-th>
            <vs-th>
              {{$t('Operation_type')}}
            </vs-th>
            <vs-th>
              {{$t('Operation_method')}}
            </vs-th>
            <vs-th>
              {{$t('Balance_changes')}}(USD)
            </vs-th>
            <vs-th>
              {{$t('Complete_time')}}
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(tr, index) in data" >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.login}}
              </vs-td>

              <vs-td>
                {{getType(tr)}}
              </vs-td>
              <vs-td>
                {{tr.desc || '-'}}
              </vs-td>
              <vs-td>
                {{getSymbol(tr)}}{{ tr.amount }}
              </vs-td>
              <vs-td>
                {{ tr.createTime }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{$t('total')}}&nbsp;{{total}}&nbsp;{{$t('item')}}</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :total="pageSize"
          v-model="page"
          :max="max"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import initData from "@/mixins/initData";
import queryHeader from "@/components/fundsList/queryHeader";
export default {
  name: "index",
  components: {
    queryHeader,
  },
  data() {
    return {
      login: '',
      typeList: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo','realMobile']),
  },
  mounted(){
    this.init().then((res) => {
      this.typeList = res.data.statistics.typeList;
    });
  },
  methods: {
    beforeInit(){
      this.url = '/crm/reception/partner/queryDepositOrWithdraw'; //
      this.params = {
        page: this.page - 1,
        size: this.size,
        custId: this.userInfo.id,
        loginType: 1,
        // dataType: 1, // 1是入金, 2是出金
        status: 6,
      }
      let header = this.$refs.header;
      if(header.way){
        this.params.dataType = header.way;
      }
      if(header.type){
        this.params.payType = header.type;
      }
      if(header.date){
        this.params.startTime = header.date[0];
        this.params.endTime = header.date[1];
      }
      if(this.login){
        this.params.login = this.login;
      }
      return true;
    },
    getType(item){
      if(item.type == 1){
        return this.$t('Trade.depo'); //入金
      }else if(item.type == 2){
        return this.$t('User.out'); //出金
      }
    },
    getSymbol(item){
      if(item.type == 1){
        return '+';
      }else if(item.type == 2){
        return '-';
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    }
  },
}
</script>

<style lang="scss">
.funds-list {

}
</style>
